<template>
  <div class="lucky-dialog" @touchmove.prevent>
    <div class="mask" v-if="maskShow"></div>
    <div class="lucky-dialog-main" :class="{ starAnim: isStartAnim }">
      <div class="lucky-top">
        <div class="user-img"><img v-lazy="dataInfo.HeadPortraitUrl" alt="" /></div>
        <p class="nickname">{{ dataInfo.Nick || '搜货精选' }}</p>
        <p class="desc">发放待返金额</p>
        <p class="txt">恭喜发财,&nbsp;&nbsp;大吉大利</p>
        <div class="radius-border"></div>
      </div>
      <div class="lucky-btm">
        <div class="btm-radius-border"></div>
      </div>
      <div class="money-box" v-if="moneyBoxShow">
        <div class="money-open" v-show="showOpenBtn" @click="openLuckyPacket">開</div>
        <div class="money" v-show="!showOpenBtn">
          <div class="face"></div>
          <div class="side" style="transform: translateZ(1px)"></div>
          <div class="side" style="transform: translateZ(2px)"></div>
          <div class="side" style="transform: translateZ(3px)"></div>
          <div class="side" style="transform: translateZ(4px)"></div>
          <div class="side" style="transform: translateZ(5px)"></div>
          <div class="side" style="transform: translateZ(6px)"></div>
          <div class="side" style="transform: translateZ(7px)"></div>
          <div class="side" style="transform: translateZ(8px)"></div>
          <div class="face"></div>
        </div>
        <div class="money-anim"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    // 是否展示钱币动画
    showOpenBtn: {
      type: Boolean,
      default: true
    },
    // 是否显示遮罩层
    maskShow: {
      type: Boolean,
      default: true
    },
    // ‘開’按钮模块是否展示
    moneyBoxShow: {
      type: Boolean,
      default: true
    },
    // 钱包弹弹窗关闭时是否开启动画
    isStartAnim: {
      type: Boolean,
      default: false
    },
    dataInfo: {
      type: Object,
      require: true,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    // 打开钱包
    openLuckyPacket() {
      this.$emit('openLuckyPacket')
    }
  }
}
</script>

<style scoped>
.lucky-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
}
.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.7);
}
.lucky-dialog-main {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -55%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 5px;
  box-sizing: border-box;
  width: 85%;
  height: 66%;
  animation: dialogAnim 300ms 50ms ease-in-out;
  animation-fill-mode: backwards;
  overflow: hidden;
  z-index: 1000;
}
.lucky-top {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 60%;
  background: #ce4d42;
  font-size: 14px;
  z-index: 10;
}
.user-img {
  width: 65px;
  height: 65px;
  z-index: 10;
  margin-top: 10%;
}
.user-img img {
  height: 100%;
  width: 100%;
  border-radius: 5px;
}
.lucky-top > p {
  z-index: 10;
  color: #ffd4bc;
}
.lucky-top .nickname {
  margin-top: 10px;
  font-size: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.lucky-top .desc {
  margin-top: 4px;
  color: #ffceae;
  font-size: 16px;
}
.lucky-top .txt {
  font-size: 22px;
  margin-top: 20px;
}
.lucky-top .radius-border {
  position: absolute;
  height: 45%;
  bottom: -16%;
  left: -3%;
  width: 106%;
  background: #ce4d42;
  border-radius: 50%;
  box-shadow: 0 2px 2px 0 #bf423b;
  z-index: 2;
}
.lucky-btm {
  position: relative;
  width: 100%;
  height: 40%;
  background: #c3473f;
  overflow: hidden;
}
.lucky-btm .btm-radius-border {
  position: absolute;
  height: 66%;
  top: -44%;
  left: -3%;
  width: 106%;
  background: #fff;
  border-radius: 50%;
  z-index: 1;
}
.starAnim .lucky-top {
  animation: leaveAnim 0.3s 0.3s ease-out;
  animation-fill-mode: forwards;
}
.starAnim .lucky-btm {
  animation: leaveBtmAnim 0.3s 0.3s ease-out;
  animation-fill-mode: forwards;
}
/* ------------ money ------------- */
.money-box {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20%;
  z-index: 15;
}
.money-open {
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-radius: 50%;
  background: #f2d19a;
  color: #333;
  font-size: 30px;
}
.money {
  width: 100px;
  height: 100px;
  position: absolute;
  transform-style: preserve-3d;
  animation: spin 0.8s linear infinite;
}
.face {
  width: 100px;
  height: 100px;
  background: url('../../../assets/image/money.png');
  background-size: 100% 100%;
  border-radius: 50%;
}
.side {
  position: absolute;
  top: 0;
  width: 100px;
  height: 100px;
  background: url('../../../assets/image/money_deep.png');
  background-size: 100% 100%;
  border-radius: 50%;
  transform: translateZ(1px);
}
.face:last-child {
  position: absolute;
  top: 0;
  transform: translateZ(9px);
}
@media screen and (max-height: 568px) {
  .money-open,
  .money-box,
  .money,
  .face,
  .side {
    height: 70px;
    width: 70px;
    line-height: 70px;
  }
}
@media screen and (max-height: 480px) {
  .money-box {
    bottom: 14%;
  }
}
/* -------- animation -------- */
@keyframes dialogAnim {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes spin {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(-360deg);
  }
}
@keyframes leaveAnim {
  0% {
    transform: translateY(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(-40%);
    opacity: 0;
  }
}
@keyframes leaveBtmAnim {
  0% {
    transform: translateY(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(28%);
    opacity: 0;
  }
}
</style>
